<div class="modal-backdrop" [style.z-index]="getZIndex()" data-testid="modal-backdrop">
  <div class="modal-dialog" [attr.data-size]="getSize()"
    [attr.aria-label]="config.ariaLabel || config.title || 'Modal dialog'" role="dialog" aria-modal="true"
    (clickOutside)="onBackdropClick()" data-testid="modal-dialog">
    <!-- Header -->
    @if (showHeader) {
    <div class="modal-header" data-testid="modal-header">
      <h2 class="modal-title text-lg text-bold">{{ config.title }}</h2>
      @if (config.showCloseButton !== false) {
      <app-button variant="icon" (click)="onCloseClick()" [attr.aria-label]="'component.modal.close' | translate"
        data-testid="modal-close-button">
        <app-icon name="x" />
      </app-button>
      }
    </div>
    }

    <!-- Content (dynamic component injected here by ModalContainerComponent) -->
    <div class="modal-content" data-testid="modal-content">
      <ng-content></ng-content>
    </div>

    <!-- Footer with action buttons -->
    @if (showFooter) {
    <div [className]="'modal-footer ' + config.footerClassName" data-testid="modal-footer">
      @for (button of config.actionButtons; track button.id || button.label) {
      <app-button [disabled]="isButtonDisabled(button)" [variant]="getButtonVariant(button)"
        [color]="button.variant === 'danger' ? 'danger' : 'primary'" (click)="onActionButtonClick(button, $event)"
        [className]="button.className"
        [attr.data-testid]="button.testId || ('modal-button-' + (button.id || button.label))">
        {{ button.label }}
      </app-button>
      }
    </div>
    }
  </div>
</div>